import i18n from '@/i18n';

/**
 * This is an object of functions that each produce valid responses. There's no
 * need for these to be 1-1 with english, feel free to change the wording or
 * use/not use any of the variables available in the object or the
 * arguments for the message to make the most sense in your language and culture.
 *
 * The validation context object includes the following properties:
 * {
 *   args        // Array of rule arguments: between:5,10 (args are ['5', '10'])
 *   name:       // The validation name to be used
 *   value:      // The value of the field (do not mutate!),
 *   vm: the     // FormulateInput instance this belongs to,
 *   formValues: // If wrapped in a FormulateForm, the value of other form fields.
 * }
 */

const localizedValidationMessages = {
    /**
     * The date is not after.
     */
    after: function ({ name, args }) {
        if (Array.isArray(args) && args.length) {
            return i18n.t('form.validations.after_arg')
                .replace('%name%', name)
                .replace('%arg%', args[0])
        }
        return i18n.t('form.validations.after')
            .replace('%name%', name)
    },

    /**
     * The date is not before.
     */
    before: function ({ name, args }) {
        if (Array.isArray(args) && args.length) {
            return i18n.t('form.validations.before_arg')
                .replace('%name%', name)
                .replace('%arg%', args[0])
        }
        return i18n.t('form.validations.before')
            .replace('%name%', name)
    },

    /**
     * Is not a valid date.
     */
    date: function ({ name, args }) {
        if (Array.isArray(args) && args.length) {
            return i18n.t('form.validations.date_format')
                .replace('%name%', name)
                .replace('%arg%', args[0])
        }
        return i18n.t('form.validations.date')
            .replace('%name%', name)
    },

    /**
     * The default render method for error messages.
     */
    default: function () {
        return i18n.t('form.validations.default')
    },

    /**
     * Required field.
     */
    required: function () {
        return i18n.t('form.validations.required')
    },
}

export default localizedValidationMessages;